
import { defineComponent } from 'vue'

import BackLink from '@/components/BackLink.vue'

export default defineComponent({
  components: { BackLink },
  props: {
    hasUnsavedChanges: {
      type: Boolean,
      required: true,
      default: false
    },
    parent: {
      type: Object,
      default: null
    }
  },
  emits: ['on-save', 'on-discard']
})
